import apiClient from './apiClient';

// Get Revenue Data
export const getRevenueApi = async (params) => {
  const response = await apiClient.get('/partners/almata-partners/oem-partners/revenue', { params });
  return response.data;
};